var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"close-btn"},[_c('i',{staticClass:"el-icon-close",on:{"click":_vm.close}})])
}
var staticRenderFns = []

export { render, staticRenderFns }